import { IApplicationData } from "../../model/application-data";
import { IAuthenticationData } from "../../model/authentication-data";
import { IAuthenticationResponse } from "../../model/security/response/authentication-response";
import LocalEnvironment from "./local-environment";
import { getProductName } from "./govhub-brand";

const getApplicationData = (): IApplicationData => {

    var applicationData = {} as IApplicationData;

    var url = window.location.hostname.toLowerCase();

    var moduleApi = url.includes("sdp") ? "sdp" : url.includes("scp") ? "scp" : url.includes("sge") ? "sge" : url.includes("apm") ? "apm" : url.includes("ser") ? "ser" : url.includes("ouv") ? "ouv" : url.includes("sic") ? "sic" : "";

    var autenticacaoApi = "autenticacao";

    if (url.includes("sand")) {
        moduleApi += "-sand";
        autenticacaoApi += "-sand";
    }

    if (url.includes("sdp")) {
        applicationData.moduleId = 1
        applicationData.moduleName = "SDP"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Diagramação e Publicação";
    } else if (url.includes("scp")) {
        applicationData.moduleId = 9
        applicationData.moduleName = "SCP"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Contratações Públicas";
    } else if (url.includes("sge")) {
        applicationData.moduleId = 10
        applicationData.moduleName = "SGE"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Emendas Parlamentares";
    } else if (url.includes("apm")) {
        applicationData.moduleId = 3
        applicationData.moduleName = "APM"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Gestão de Portal da Entidade";
    } else if (url.includes("ser")) {
        applicationData.moduleId = 2
        applicationData.moduleName = "SER"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Envio de Remessas";
    } else if (url.includes("ouv")) {
        applicationData.moduleId = 7
        applicationData.moduleName = "OUV"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Ouvidoria";
    } else if (url.includes("sic")) {
        applicationData.moduleId = 4
        applicationData.moduleName = "SIC"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Serviço de Informação ao Cidadão";
    }

    if (url.includes("ipmbrasil")) {
        applicationData.multitenant = 7
        applicationData.baseUrlAuthentication = "http://account.api.ipmbrasil.org.br/";
        applicationData.baseUrl = moduleApi === "apm" || moduleApi === "ser" || moduleApi === "ouv" || moduleApi === "sic" ? `http://${moduleApi}.api.ipmbrasil.org.br/` : "http://scp.api.ipmbrasil.org.br/";
    } else if (url.includes("docgedsistemas")) {
        applicationData.multitenant = 3851
        applicationData.baseUrlAuthentication = `https://api.${autenticacaoApi}.docgedsistemas.com.br/`;
        applicationData.baseUrl = `https://api.${moduleApi}.docgedsistemas.com.br/`;
    } else if (url.includes("airdoc")) {
        applicationData.multitenant = 3901
        applicationData.baseUrlAuthentication = `https://api.${autenticacaoApi}.airdoc.com.br/`;
        applicationData.baseUrl = `https://api.${moduleApi}.airdoc.com.br/`;
    }

    if (LocalEnvironment.isLocalhost()) {
        applicationData = LocalEnvironment.getApplicationData();
    }

    applicationData.productName = getProductName(applicationData.moduleId);
    applicationData.isSandbox = url.includes("sand");

    return applicationData;
};

const getAuthenticationData = (): IAuthenticationData | undefined => {
    let value = localStorage.getItem("session_application") as string;
    return JSON.parse(value);
};

const setAuthenticationData = (data: IAuthenticationResponse) => {
    const application = Object.assign({} as IAuthenticationData, data)
    localStorage.setItem("session_application", JSON.stringify(application));
};

const clearAuthenticationData = () => {
    localStorage.removeItem("session_application");
};


const ApplicationAppService = {
    getAuthenticationData, setAuthenticationData, clearAuthenticationData, getApplicationData
};

export default ApplicationAppService;